<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" [dir]="dir"
  [ngClass]="{'minisidebar': minisidebar, 'boxed': boxed, 'danger': danger, 'blue': blue, 'green': green, 'dark': dark }">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="primary" class="topbar telative">

    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header">
      <a class="navbar-brand" href="/">
        <!-- Logo icon -->
        <b fxShow="true">
          <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
          <!-- Dark Logo icon -->
          <img src="assets/images/brasao.png" alt="homepage" class="dark-logo">
          <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo">
          <!-- Light Logo icon  logo-light-icon.png -->
          <img src="assets/images/cecam_logo_2.jpg" alt="homepage" class="light-logo"
            style="height: 55px; width:55px; border: 0.25px solid rgb(16, 70, 125); border-radius: 8%;">
        </b>
        <!--End Logo icon -->
        <!-- Logo text -->
        <span fxShow="true" fxShow.gt-xs>
          <!-- dark Logo text -->
          <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo">
          <!-- Light Logo text NOME DO SISTEMA-->
          <!--<img src="assets/images/logo-light-text.png" class="light-logo" alt="homepage">-->
        </span>
      </a>
    </div>

    <!-- ============================================================== -->
    <!-- sidebar toggle -->
    <!-- ============================================================== -->
    <button mat-icon-button class="m-r-5" (click)="snav.toggle() && clickEvent()" value="sidebarclosed">
      <mat-icon>menu</mat-icon>
    </button>

    <span class="header-title hide-mobile">
     {{ this.onEntidade() }}
    </span>

    <!-- ============================================================== -->
    <!-- Search - style you can find in header.scss -->
    <!-- ============================================================== -->
    <!--
      <button mat-icon-button class="srh-btn" (click)="showSearch = !showSearch">
        <mat-icon>search</mat-icon>
      </button>
    -->
    <form class="app-search" [ngClass]="{'show-search': showSearch}">
      <input type="text" class="form-control" placeholder="Search &amp; enter">
      <a class="cl-srh-btn" (click)="showSearch = !showSearch">
        <i class="ti-close"></i>
      </a>
    </form>
    <span fxFlex></span>




    <!-- ============================================================== -->
    <!-- app header component - style you can find in header.scss / header.component.ts-->
    <!-- ============================================================== -->
    <app-header></app-header>
    <!-- ============================================================== -->
    <!-- Right sidebar toggle - style you can find in rightsidebar.component.scss -->
    <!-- ============================================================== -->
    <button (click)="end.toggle()" mat-icon-button class="ml-xs overflow-visible">
      <mat-icon>brightness_6</mat-icon>
    </button>
  </mat-toolbar>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
    [ngClass]="{'minisidebar': minisidebar}">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
      [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true"
      (close)="sidebarOpened = false" [perfectScrollbar]="config">

      <app-sidebar class="app-sidebar"></app-sidebar>

    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right Sidebar - style you can find in rightsidebar.component.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #end position="end" class="chat-panel" mode="over" opened="false">
      <div class="scroll">
        <mat-nav-list>

          <h3 mat-subheader class="text-uppercase font-weight-bold">Contraste</h3>
          <mat-list-item>
            <mat-slide-toggle [(ngModel)]="dark" (change)="green = blue = danger = false">Contraste
              Preto</mat-slide-toggle>
            <!--
                <mat-checkbox color="warn" [(ngModel)]="danger" (change)="green = blue = false" class="text-danger">Red
                <mat-checkbox color="warn" [(ngModel)]="green" (change)="danger = blue = false" class="text-megna">Teal
                <mat-checkbox color="warn" [(ngModel)]="blue" (change)="green = danger = false" class="text-info">Blue
              -->
          </mat-list-item>
          <mat-divider></mat-divider>`

          <h3 mat-subheader class="text-uppercase font-weight-bold">Acessibilidade</h3>
          <mat-list-item>
            <button mat-icon-button class="ml-xs overflow-visible" [routerLink]='["/acessibilidade"]'>
              <mat-icon>accessibility</mat-icon> Libras
            </button>
          </mat-list-item>
          <mat-divider></mat-divider>

          <h3 mat-subheader class="text-uppercase font-weight-bold">Zoom</h3>
          <mat-list-item>
            <div class="acessibilidade-item-a-mais">
              <input type="button" id="increasefont" title="A +" name="A +" value="A +" onclick="fonte('a');" />
            </div>
            <div class="acessibilidade-item-a-menos">
              <input type="button" style="margin: 10px" id="decreasefont" title="A -" name="A -" value="A -"
                onclick="fonte('d');" />
            </div>
          </mat-list-item>
          <mat-list-item></mat-list-item>

          <mat-divider></mat-divider>

          <h3 mat-subheader *ngIf="false" class="text-uppercase font-weight-bold">Preferências</h3>
          <mat-list-item *ngIf="false">
            <mat-slide-toggle color="warn" (change)="dir = (dir == 'rtl' ? 'ltr' : 'rtl')">Inverter
              Menu</mat-slide-toggle>
          </mat-list-item>

          <mat-list-item *ngIf="false">
            <mat-slide-toggle color="warn" [(ngModel)]="boxed">Tela em Container</mat-slide-toggle>
          </mat-list-item>

          <mat-list-item *ngIf="false">
            <mat-slide-toggle [(ngModel)]="minisidebar">Reduzir Menu</mat-slide-toggle>
          </mat-list-item>
          <mat-divider></mat-divider>

        </mat-nav-list>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper" [ngClass]="status ? 'minitoggle' : ''">

      <app-breadcrumb></app-breadcrumb>
      <div class="page-content">
        <router-outlet>
          <app-spinner></app-spinner>
        </router-outlet>

      </div>

    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
